<template>
  <div class="otoCon">
    <div  class="broadcastbbsList">
        <div class="error_title">
            {{language.error}}
        </div>
    </div>
  </div>
</template>
<script>

  export default {
    props:{
      language:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    data(){
      return {
      }
    },
    methods:{
    }
  }
</script>
<style scoped>
  .error_title {
    font-size: 16px;
    text-align: center;
    color: #424242;
    font-family: "Microsoft YaHei";
  }
  .broadcastbbsList {
    width: 100%;
    background: #fff;
    margin-top: 10px;
    -webkit-box-shadow: 0px 5px 6px rgba(205, 205, 205, 0.7);
    box-shadow: 0px 5px 6px rgba(205, 205, 205, 0.7);
    padding: 22px;
    padding-left: 38px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
</style>